@if (title(); as titleValue) {
  <div class="header">{{ titleValue }}</div>
}
<div class="row">
  @if (color(); as colorValue) {
    <span class="marker" [style.background-color]="colorValue"></span>
  }
  <span class="label">{{ label() }}</span>
  <span class="value">{{ value() }}</span>
</div>
